// src/store/thunks/createAdmin/createAdminThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { AdminUpsertDTO, AdminEntity } from '@/types/administrators.types';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';

export const createAdminThunk = createAdminAsyncThunk<
  AdminEntity,
  AdminUpsertDTO
>(
  'administrators/create',
  withLoader(
    withErrorHandling(
      async(dto, { extra: { administratorsService } }) =>
        await administratorsService.create(dto)
    )
  )
);
